import { InfoOutlineIcon, UpdateOutlineIcon } from '@carboncopyco/icons';
import { Badge, ColorHex, TextBase, Tooltip } from '@carboncopyco/ui';
import { Item } from '@radix-ui/react-dropdown-menu';
import classnames from 'classnames';
import { type ReactNode, useRef } from 'react';
import { useDesktopDeeplink } from '../../utils/hooks/useDesktopDeeplink';
import { CustomDropdownItemStyles } from './CustomDropdownItemStyles';

export interface ContinueCloningMenuItemProps {
  onSelect: () => void;
  timeLeftToEditClone: string | null;
  learnMore: ReactNode;
  ldFlag: number;
}

export const ContinueCloningMenuItem = ({
  onSelect,
  timeLeftToEditClone,
  learnMore,
  ldFlag,
}: ContinueCloningMenuItemProps) => {
  const infoTooltipRef = useRef<HTMLDivElement>(null);
  const disabled = ldFlag && !timeLeftToEditClone;
  const { exeDeeplink } = useDesktopDeeplink();
  return (
    <>
      <CustomDropdownItemStyles />
      <Item
        onClick={(event) => event.stopPropagation()}
        disabled={!!disabled}
        className="time-limit-item"
        onSelect={() => {
          if (!disabled) {
            exeDeeplink('continueCloning', 'true', onSelect);
          }
        }}
      >
        <div
          className={classnames('flex items-center rounded p-2.5 w-full', {
            'cursor-pointer': !disabled,
          })}
        >
          <div className="mr-2 icon-wrapper">
            <UpdateOutlineIcon
              color={disabled ? ColorHex.natural200 : ColorHex.natural600}
            />
          </div>
          <div className="flex items-center gap-3 whitespace-nowrap">
            <TextBase
              label="Continue cloning"
              color={disabled ? 'text-ds-natural' : 'text-ds-natural-600'}
            />
          </div>
          {ldFlag ? (
            <>
              <div
                ref={infoTooltipRef}
                className="ml-2"
              >
                <InfoOutlineIcon
                  size={20}
                  color={disabled ? ColorHex.natural200 : ColorHex.natural600}
                />
              </div>
              <div onClick={(event) => event.stopPropagation()}>
                <Tooltip
                  interactive
                  shadow="md"
                  placement="bottom-end"
                  anchorRef={infoTooltipRef}
                  noArrow
                >
                  <div className="w-ds-330 p-3 cursor-auto">
                    <TextBase
                      label={`Continue cloning is only available for ${ldFlag} days after the clone was created.`}
                      color="text-ds-natural-600"
                    />
                    {learnMore}
                  </div>
                </Tooltip>
              </div>
            </>
          ) : null}
          {timeLeftToEditClone && (
            <div className="ml-2 whitespace-nowrap">
              <Badge
                variant="yellow"
                label={timeLeftToEditClone}
              />
            </div>
          )}
        </div>
      </Item>
    </>
  );
};
